(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9688],{

/***/ 39688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LayoutWidget066": function() { return /* binding */ LayoutWidget066; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52853);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87900);
/* harmony import */ var shared_contexts_PageData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65202);
/* harmony import */ var _LayoutWidget066_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54326);
/* harmony import */ var _LayoutWidget066_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_LayoutWidget066_module_scss__WEBPACK_IMPORTED_MODULE_7__);








var LayoutWidget066 = function(param) {
    var payload = param.payload;
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_2__/* .buildWidgetInstanceId */ .G1)("l066", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_3__/* .WIDGETS_REGISTRY["LAYOUT-WIDGET"] */ .R["LAYOUT-WIDGET"]);
    var forms = (0,shared_contexts_PageData__WEBPACK_IMPORTED_MODULE_5__/* .useCollectedData */ .M)(instanceId, [
        {
            name: "forms",
            defaultValue: []
        }, 
    ]).forms;
    var _forms = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(forms, 1), form = _forms[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_LayoutWidget066_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                item: form,
                instanceId: instanceId
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LayoutWidget066);


/***/ }),

/***/ 54326:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutWidget066_wrapper__pSOE_"};

/***/ })

}]);